var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{key:_vm.data.title,staticClass:"btnWithoutBubble",on:{"click":function($event){return _vm.buttonSendAction(_vm.data.payload)}}},[_vm._v(_vm._s(_vm.data.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }